var _mask, _rect, _mask2, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnWiredLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3036_71535",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.42285,
    width: 24,
    height: 19,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.42285,
    width: 24,
    height: 19,
    rx: 1,
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_3036_71535)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3036_71535",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4004 12.3232V9.32324H25.5996V12.3232L30.4004 12.3232V24.9238H13.5996V12.3232H18.4004Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4004 12.3232V13.8232H19.9004V12.3232H18.4004ZM18.4004 9.32324V7.82324H16.9004V9.32324H18.4004ZM25.5996 9.32324H27.0996V7.82324H25.5996V9.32324ZM25.5996 12.3232H24.0996V13.8232H25.5996V12.3232ZM30.4004 12.3232H31.9004V10.8232H30.4004V12.3232ZM30.4004 24.9238V26.4238H31.9004V24.9238H30.4004ZM13.5996 24.9238H12.0996V26.4238H13.5996V24.9238ZM13.5996 12.3232V10.8232H12.0996V12.3232H13.5996ZM18.4004 12.3232H19.9004V9.32324H18.4004H16.9004V12.3232H18.4004ZM18.4004 9.32324V10.8232H25.5996V9.32324V7.82324H18.4004V9.32324ZM25.5996 9.32324H24.0996V12.3232H25.5996H27.0996V9.32324H25.5996ZM25.5996 12.3232V13.8232L30.4004 13.8232V12.3232V10.8232L25.5996 10.8232V12.3232ZM30.4004 12.3232H28.9004V24.9238H30.4004H31.9004V12.3232H30.4004ZM30.4004 24.9238V23.4238H13.5996V24.9238V26.4238H30.4004V24.9238ZM13.5996 24.9238H15.0996V12.3232H13.5996H12.0996V24.9238H13.5996ZM13.5996 12.3232V13.8232H18.4004V12.3232V10.8232H13.5996V12.3232Z",
    fill: "white",
    mask: "url(#path-3-inside-2_3036_71535)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31.9053H20.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 31.9053H29.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.9053L22.5 27.9053",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 32.1768,
    r: 1.75,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnWiredLight);
export default __webpack_public_path__ + "static/media/btn_wired_light.9e33f4b0c69e31b20123e44e4c206017.svg";
export { ForwardRef as ReactComponent };